import React, { useState, useRef, useEffect } from 'react';
import './OtpInput.css';

const OtpInput = ({ length = 6, value, onChange }) => {
  const [otp, setOtp] = useState(value ? value.split('') : Array(length).fill(''));
  const inputRefs = useRef([]);

  useEffect(() => {
    const otpArray = Array(length).fill('');
    if (value) {
      value.split('').forEach((char, i) => {
        if (i < length) otpArray[i] = char;
      });
    }
    setOtp(otpArray);
  }, [value, length]);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      onChange(newOtp.join(''));

      // Move to next input
      if (index < length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        // Move to previous input
        inputRefs.current[index - 1].focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
        onChange(newOtp.join(''));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text');
    const pasteArray = paste.slice(0, length).split('');
    const newOtp = [...otp];
    pasteArray.forEach((char, i) => {
      if (/^\d$/.test(char)) {
        newOtp[i] = char;
      }
    });
    setOtp(newOtp);
    onChange(newOtp.join(''));
  };

  return (
    <div className="otp-input-container">
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          maxLength={1}
          className="otp-input"
          style={{
            borderRadius: 8
          }}
        />
      ))}
    </div>
  );
};

export default OtpInput;